// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2oN74","image":"style_image__3EYAd"};